import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ContentProvider } from "@/context/ContentContext";
import HeadInjector from "@/components/HeadInjector";
import RouteTracker from "@/components/RouteTracker";
import NewsletterPopup from "@/components/NewsletterPopup";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Servicos from "@/pages/Servicos";
import ComoTrabalhamos from "@/pages/ComoTrabalhamos";
import Remodelacoes from "@/pages/Remodelacoes";
import Portfolio from "@/pages/Portfolio";
import ProjectDetail from "@/pages/ProjectDetail";
import SobreNos from "@/pages/SobreNos";
import Orcamento from "@/pages/Orcamento";
import Contactos from "@/pages/Contactos";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Unsubscribe from "@/pages/Unsubscribe";
import Privacidade from "@/pages/Privacidade";
import Cookies from "@/pages/Cookies";
import NotFound from "@/pages/NotFound";
import ClientArea from "@/pages/ClientArea";
import PartnerApp from "@/pages/partner/PartnerApp";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminObrasEmCurso from "@/pages/admin/AdminObrasEmCurso";
import AdminParceiros from "@/pages/admin/AdminParceiros";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminServices from "@/pages/admin/AdminServices";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSpecialties from "@/pages/admin/AdminSpecialties";
import AdminContent from "@/pages/admin/AdminContent";
import AdminLandings from "@/pages/admin/AdminLandings";
import AdminSEO from "@/pages/admin/AdminSEO";
import AdminBeforeAfter from "@/pages/admin/AdminBeforeAfter";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import LandingLisboa from "@/pages/LandingLisboa";
import LandingOeiras from "@/pages/LandingOeiras";
import LandingCascais from "@/pages/LandingCascais";
import LandingSintra from "@/pages/LandingSintra";
import LandingSetubal from "@/pages/LandingSetubal";
import LandingSantarem from "@/pages/LandingSantarem";

function Protected({ children }) {
    const { user, checked } = useAuth();
    if (!checked || user === null) return <div className="min-h-screen flex items-center justify-center text-stone-500">A carregar…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

export default function App() {
    return (
        <SettingsProvider>
            <ContentProvider>
            <AuthProvider>
                <BrowserRouter>
                    <HeadInjector />
                    <RouteTracker />
                    <NewsletterPopup />
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        <Route element={<PublicLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/servicos" element={<Servicos />} />
                            <Route path="/como-trabalhamos" element={<ComoTrabalhamos />} />
                            <Route path="/codigo-h" element={<Navigate to="/sobre-nos" replace />} />
                            <Route path="/remodelacoes" element={<Remodelacoes />} />
                            <Route path="/remodelacoes-lisboa" element={<LandingLisboa />} />
                            <Route path="/remodelacoes-oeiras" element={<LandingOeiras />} />
                            <Route path="/remodelacoes-cascais" element={<LandingCascais />} />
                            <Route path="/remodelacoes-sintra" element={<LandingSintra />} />
                            <Route path="/remodelacoes-setubal" element={<LandingSetubal />} />
                            <Route path="/remodelacoes-santarem" element={<LandingSantarem />} />
                            <Route path="/transformacoes" element={<Navigate to="/trabalhos" replace />} />
                            <Route path="/trabalhos" element={<Portfolio />} />
                            <Route path="/trabalhos/:slug" element={<ProjectDetail />} />
                            <Route path="/sobre-nos" element={<SobreNos />} />
                            <Route path="/orcamento" element={<Orcamento />} />
                            <Route path="/contactos" element={<Contactos />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/unsubscribe" element={<Unsubscribe />} />
                            <Route path="/privacidade" element={<Privacidade />} />
                            <Route path="/cookies" element={<Cookies />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/cliente/:token" element={<ClientArea />} />
                        <Route path="/parceiros/*" element={<PartnerApp />} />
                        <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="leads" element={<AdminLeads scope="inbox" />} />
                            <Route path="clientes" element={<AdminLeads scope="clients" />} />
                            <Route path="obras-em-curso" element={<AdminObrasEmCurso />} />
                            <Route path="parceiros" element={<AdminParceiros />} />
                            <Route path="projetos" element={<AdminProjects />} />
                            <Route path="antes-depois" element={<AdminBeforeAfter />} />
                            <Route path="servicos" element={<AdminServices />} />
                            <Route path="especialidades" element={<AdminSpecialties />} />
                            <Route path="testemunhos" element={<AdminTestimonials />} />
                            <Route path="blog" element={<AdminBlog />} />
                            <Route path="newsletter" element={<AdminNewsletter />} />
                            <Route path="analytics" element={<AdminAnalytics />} />
                            <Route path="conteudos" element={<AdminContent />} />
                            <Route path="landings" element={<AdminLandings />} />
                            <Route path="seo" element={<AdminSEO />} />
                            <Route path="definicoes" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            </ContentProvider>
        </SettingsProvider>
    );
}
